// Horizon Theme - Events.js
// Gère les interactions globales du thème (menus, modales, sliders, etc.)

document.addEventListener('DOMContentLoaded', () => {
  // Gestion des menus déroulants
  const dropdowns = document.querySelectorAll('[data-dropdown]');
  dropdowns.forEach(drop => {
    drop.addEventListener('click', () => {
      drop.classList.toggle('open');
    });
  });

  // Fermeture des modales au clic sur le fond
  const modals = document.querySelectorAll('.modal');
  modals.forEach(modal => {
    modal.addEventListener('click', e => {
      if (e.target.classList.contains('modal')) {
        modal.classList.remove('open');
      }
    });
  });

  // Animation fade-in au scroll
  const els = document.querySelectorAll('.fade-in');
  const obs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.2 });
  els.forEach(el => obs.observe(el));

  // Gestion du bouton retour en haut
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        backToTop.classList.add('show');
      } else {
        backToTop.classList.remove('show');
      }
    });
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
  // Effet doré au survol des boutons
  const buttons = document.querySelectorAll('.button-primary, .button-secondary, .newsletter button');
  buttons.forEach(btn => {
    btn.addEventListener('mouseenter', () => {
      btn.style.boxShadow = '0 0 20px rgba(218,191,122,0.8)';
      btn.style.transform = 'scale(1.05)';
      btn.style.transition = 'all 0.3s ease';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.boxShadow = 'none';
      btn.style.transform = 'scale(1)';
    });
  });
